import { render, staticRenderFns } from "./FarmLocation.vue?vue&type=template&id=47d65e40&scoped=true"
import script from "./FarmLocation.vue?vue&type=script&lang=js"
export * from "./FarmLocation.vue?vue&type=script&lang=js"
import style0 from "./FarmLocation.vue?vue&type=style&index=0&id=47d65e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d65e40",
  null
  
)

export default component.exports